module.exports = __webpack_public_path__ + "xero-disconnect-white.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/xero-disconnect-white.svg
// module id = TA7C
// module chunks = 0